import React from 'react';
import { Home, ArrowRightLeft, BookOpen, Activity, User } from 'lucide-react';

/**
 * Bottom Navigation Bar — 5 tabs, light mode, fintech-grade
 * Tabs: Home, Trade, Learn, Performance, Profile
 */
const BottomNavNew = ({ activeTab, onTabChange }) => {
  const tabs = [
    { id: 'home', label: 'Home', icon: Home },
    { id: 'trade', label: 'Trade', icon: ArrowRightLeft },
    { id: 'learn', label: 'Learn', icon: BookOpen },
    { id: 'performance', label: 'Stats', icon: Activity },
    { id: 'profile', label: 'Profile', icon: User },
  ];

  return (
    <nav
      data-testid="bottom-nav-new"
      style={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        height: '68px',
        background: 'rgba(255, 255, 255, 0.92)',
        backdropFilter: 'blur(20px)',
        WebkitBackdropFilter: 'blur(20px)',
        borderTop: '1px solid #E2E8F0',
        display: 'flex',
        justifyContent: 'space-around',
        alignItems: 'center',
        paddingBottom: 'env(safe-area-inset-bottom, 4px)',
        zIndex: 100,
      }}
    >
      {tabs.map((tab) => {
        const isActive = activeTab === tab.id;
        const Icon = tab.icon;

        return (
          <button
            key={tab.id}
            data-testid={`nav-${tab.id}`}
            onClick={() => onTabChange(tab.id)}
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: '3px',
              padding: '6px 12px',
              background: 'transparent',
              border: 'none',
              cursor: 'pointer',
              transition: 'all 0.2s ease',
            }}
          >
            <div style={{
              width: '36px',
              height: '36px',
              borderRadius: '12px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              background: isActive ? 'rgba(245, 166, 35, 0.12)' : 'transparent',
              transition: 'all 0.2s ease',
            }}>
              <Icon
                size={22}
                strokeWidth={isActive ? 2.2 : 1.8}
                color={isActive ? '#F5A623' : '#94A3B8'}
              />
            </div>
            <span style={{
              fontSize: '10px',
              fontWeight: isActive ? '700' : '500',
              color: isActive ? '#F5A623' : '#94A3B8',
              fontFamily: 'Inter, sans-serif',
              letterSpacing: '0.02em',
            }}>
              {tab.label}
            </span>
          </button>
        );
      })}
    </nav>
  );
};

export default BottomNavNew;
